import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-common-helper',
  templateUrl: './common-helper.component.html',
  styleUrls: ['./common-helper.component.css']
})
export class CommonHelperComponent implements OnInit {
  message: string = 'Are you sure want to delete.'
  matDialogData: any;

  constructor(public dialogRef: MatDialogRef<CommonHelperComponent>,
    @Inject(MAT_DIALOG_DATA) data: any) {
      this.matDialogData = data;
     }

  ngOnInit(): void {
    this.message = this.matDialogData.message;
  }

  decisionClick(event: any) {
    this.dialogRef.close(event);
  }

}
